import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';
import { typeOf } from './types';

export default function TypeFields({ type, f, setF }) {
  const t = typeOf(type);
  if (!t.fields.length) { return null; }
  const fields = t.fields.filter((d) => !d.toolOnly || f.is_tool);
  return (
    <section className="space-y-2" data-testid="item-type-fields">
      <h4 className="text-sm font-semibold text-slate-700">{t.label} details</h4>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {fields.map((d) => {
          const v = f[d.key] ?? '';
          const tid = `item-${d.key}`;
          if (d.type === 'checkbox') {
            return <label key={d.key} className="flex items-end gap-2 text-sm pb-2"><Checkbox checked={!!f[d.key]} onCheckedChange={(c) => setF({ ...f, [d.key]: !!c })} data-testid={tid} /> {d.label}</label>;
          }
          return (
            <div key={d.key} className={d.type === 'url' ? 'col-span-2' : ''}>
              <Label className="text-xs">{d.label}</Label>
              {d.type === 'select'
                ? <select className="border rounded-md h-10 px-2 w-full text-sm" value={v} onChange={(e) => setF({ ...f, [d.key]: e.target.value })} data-testid={tid}>
                    {!d.options.includes('') && <option value="">—</option>}
                    {d.options.map((o) => <option key={o} value={o}>{o || '—'}</option>)}
                  </select>
                : <Input type={d.type === 'number' ? 'number' : d.type === 'date' ? 'date' : d.type === 'url' ? 'url' : 'text'} step="any" value={v} placeholder={d.placeholder} onChange={(e) => setF({ ...f, [d.key]: e.target.value })} data-testid={tid} />}
            </div>
          );
        })}
      </div>
      {type === 'chemical' && f.sds_url && <a href={f.sds_url} target="_blank" rel="noreferrer" className="text-xs text-sky-700 underline" data-testid="item-sds-link">Open safety data sheet</a>}
      {type === 'restaurant' && f.yield_pct ? <p className="text-xs text-slate-500">Cost per usable {f.unit || 'unit'} is the unit cost ÷ {f.yield_pct}% yield.</p> : null}
    </section>
  );
}
